<template>
  <!-- 查看、审批 -->
  <div id="detail" v-loading="loading" element-loading-text="数据处理中...">
    <div class="processHeader">
      <div class="label">
        流程详情
        <flowStatus :status="routerParams.status" />
      </div>
      <div class="rightBtn">
        <el-button v-if="(isShow === 0 || isShow === 3) && showFlowAgainButton" v-preventReClick type="primary"
          size="small" @click="flowAgain">
          流程再发起
        </el-button>
        <el-button v-if="isShow === 2" v-preventReClick size="small" type="primary" @click="withdraw">撤 回</el-button>
        <el-button size="small" @click="reback">取 消</el-button>
      </div>
    </div>
    <div class="content">
      <form-create v-if="isCustom && customData" v-model="fapi" class="create" :rule="rule" :option="option"
        @submit="onSubmit" />
      <!-- 动态组件 -->
      <component :is="businessForm" v-if="!isCustom" ref="businessForm" class="create" :list="floderData"
        :flow-definition-id="flowDefinitionId" @bindingAll="bindingAll" @refresh="refresh" />

      <!-- 流程的文件列表 -->
      <checkFlowFileEditor v-if="flowKey === 'check'" ref="checkFlowFileEditor" :files="floderData" @binding="binding">
      </checkFlowFileEditor>
      <flowFileEditor v-else ref="flowFileEditor" :files="floderData" />

      <p class="name">审批流程</p>
      <applicationFlow ref="applicationFlow" :set-flow-instance-node-id="setFlowInstanceNodeId"
        @setFlowApproveUser="setFlowApproveUser" />
      <userApprove v-if="isShowUserApprove" ref="userApprove" @getFormData="getFormData" @reback="reback" @getFloderData="getFloderData" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import formCreate from "@form-create/element-ui";
import flowService from "@/CommonDP/service/flow-service";
import flowNodesEditor from "./components/flowNodesEditor.vue";
import flowEditorLeftView from "./components/flowEditorLeftView.vue";
import commonFlowForm from "./modules/commonFlowForm.vue";
import tz from "./modules/tz/index.vue";
import check from "./modules/check/index.vue";
import leave from "./modules/leave/index.vue";
import applicationFlow from "./components/applicationFlow.vue";
import userApprove from "./components/userApprove.vue";
import flowStatus from "@/CommonDP/components/flowComponents/flowStatus";
import flowFileEditor from "./components/flowFileEditor";
import checkFlowFileEditor from "./components/checkFlowFileEditor";
export default {
  components: {
    flowEditorLeftView,
    flowNodesEditor,
    commonFlowForm,
    tz,
    check,
    leave,
    applicationFlow,
    userApprove,
    flowStatus,
    flowFileEditor,
    checkFlowFileEditor
  },
  data() {
    return {
      messageObj: {},
      flowStageName: "",
      isCustom: false, // 是否是自定义表单
      customData: false,
      processTypeList: ["common", "tz", "check", "leave"], // 目前有的审批流程类别
      businessForm: "", // 动态组件
      floderData: [],
      fapi: null,
      rule: "",
      option: "",
      loading: false,
      formId: "", // 如果是自定义，通过id查表单
      isShow: "", // 暂时不知道干嘛的
      elementPermissions: [],
      keys: [],
      flowKey: "",
      elementParams: [],
      isWorkbench: false, // 是否是工作台使用
      showFlowAgainButton: true, // 消息来的为false
      isShowUserApprove: false
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      floderObj: (state) => state.uploaderLocal.floderObj,
      enterpriseId: (state) => state.enterprise.enterpriseId,
      routerParams: (state) => state.projectMg.routerParams,
      userInfo: (state) => state.user.userInfo
    }),
    // prjId() {
    //   return this.routerParams.prjId || this.prjInfo?.prjId;
    // },
    mapComponentName() {
      if (this.routerParams.flowKey) {
        if (this.routerParams.flowKey === "common") {
          return "commonFlowForm";
        } else if (this.routerParams.flowKey === "tz") {
          return "tz";
        } else if (this.routerParams.flowKey === "leave") {
          return "leave";
        } else if (this.routerParams.flowKey === "check") {
          return "check";
        } else {
          return "commonFlowForm";
        }
      } else {
        return "commonFlowForm";
      }
    },
    statusName() {
      switch (this.routerParams.status) {
        case 1:
          return "已同意";
        case 2:
          return "审批中";
        case 3:
          return "发起";
        case 4:
          return "重新发起";
        case 5:
          return "已撤回";
        case 0:
          return "已驳回";
        default:
          return "";
      }
    },
    // cad跳转样式
    showBar() {
      if (window.location.href.indexOf("jsName=BimEx") !== -1) {
        return false;
      } else {
        return true;
      }
    },
    flowDefinitionId() {
      return this.routerParams.flowDefinitionId;
    }
  },
  watch: {},
  async mounted() {
    await this.getRouterParams();
    await this.getInit();
  },
  methods: {
    refresh() {
      if (this.routerParams.flowKey === "check") {
        this.$refs.checkFlowFileEditor.refresh();
      } else {
        this.$refs.flowFileEditor.refresh();
      }
    },
    // 获取元素权限 typt 0 查看  1  审批
    async getFormElementPermissions(type) {
      const arr = [];
      const res = await flowService.getFormElementPermissions(this.routerParams.flowBusinessId, type);
      this.elementPermissions = res.data || [];
      const res2 = await flowService.getElementList(this.formId);
      if (this.elementPermissions.length > 0) {
        res2.data.forEach((ele) => {
          this.elementPermissions.forEach((res) => {
            if (ele.elementId === res.elementID) {
              arr.push({ key: ele.field, value: res.elementPermission });
            }
          });
        });
      }
      if (this.elementPermissions.length > 0) {
        res2.data.forEach((ele) => {
          let flag = false;
          this.elementPermissions.forEach((res) => {
            if (ele.elementId === res.elementID) {
              flag = true;
              return;
            }
          });
          if (!flag) {
            arr.push({ key: ele.field, value: 1 });
          }
        });
      }
      console.log(arr);
      if (type === 0) {
        // await this.$nextTick()
        // this.fapi.disabled(true);
      } else {
        const obj = {};
        arr.forEach((ele) => {
          this.elementParams.forEach((res) => {
            if (ele.key === res.key) {
              obj[ele.key] = res.value;
            }
          });
        });
        console.log(obj);
        this.fapi.coverValue(obj);
        for (const item of arr) {
          if (item.value === 0) {
            this.fapi.hidden(true, item.key);
          } else if (item.value === 1) {
            this.fapi.disabled(true, item.key);
          } else if (item.value === 2) {
            this.fapi.disabled(false, item.key);
          }
        }
      }
    },
    async getRouterParams() {
      const flowKey = this.$route.query.flowKey;
      const enterpriseId = this.$route.query.enterpriseId;
      const { data } = await flowService.queryFlowByFlowKey(flowKey, enterpriseId);
      const params = {
        flowKey: this.$route.query.flowKey,
        flowBusinessId: this.$route.query.flowBusinessId,
        status: Number(this.$route.query.status),
        flowInstanceId: this.$route.query.flowInstanceId,
        currentNodeId: this.$route.query.currentNodeId, // 审批当前节点
        prjId: this.$route.query.prjId,
        viewParam: "view",
        enterpriseId: this.$route.query.enterpriseId,
        currentVersionId: this.$route.query.currentVersionId,
        name: this.$route.query.flowName,
        userId: this.$route.query.userId,
        clientType: Number(this.$route.query.clientType), //  发起流程来源;0web;1cad;2revit;默认0
        startFlowMode: Number(this.$route.query.startFlowMode), // 发起流程方式;0审批入口;1右键;默认0
        flowStatus: true, // 用于判断流程flowFileEditor组件下的文件能否删除
        flowDefinitionId: this.$route.query.flowDefinitionId || data.flowDefinitionId
      };
      if (params.status === 2) {
        params.viewParam = "approve";
      }
      console.log(params);
      this.$store.dispatch("setRouterParams", params);
    },
    // CAD端绑定操作
    async binding() {
      if (this.showBar) this.$message.warning("请前往cad端进行绑定操作");
    },
    // 全部绑定
    async bindingAll() {
      if (this.showBar) this.$message.warning("请前往cad端进行绑定操作");
    },
    async getInit() {
      this.flowKey = this.routerParams.flowKey;
      if (this.routerParams.showFlowAgainButton !== undefined) {
        this.showFlowAgainButton = this.routerParams.showFlowAgainButton;
      }
      console.log("当前流程数据：", this.routerParams);
      this.$refs.applicationFlow.setFlowStatus(this.routerParams.status);
      this.$refs.applicationFlow.queryCCUserIdList();
      this.formId = this.$route.query.formId;
      this.isCustom = !this.processTypeList.some((ele) => ele == this.routerParams.flowKey);
      if (this.formId && this.isCustom) {
        this.queryFormCreateData();
      } else {
        this.isCustom = false;
        this.businessForm = this.mapComponentName;
      }
      await this.getBusinessForm();
      await this.getProcessDetail();
    },
    // 查询自动表单
    async queryFormCreateData() {
      this.loading = true;
      const res = await flowService.formCreateQuery(this.formId || "41468248524324864");
      this.loading = false;
      this.option = formCreate.parseJson(JSON.stringify(res.data[0].operation) || "");
      this.rule = formCreate.parseJson(JSON.stringify(res.data[0].rule) || "");
      this.customData = true;
    },
    // 查询业务表单
    async getBusinessForm() {
      this.loading = true;
      try {
        const res = await flowService.getBusinessForm(this.routerParams.flowInstanceId);
        if (this.isCustom) {
          this.floderData = res.data.fileInfoList || [];
          const formData = res.data.object[0]?.param;
          this.keys = Object.keys(res.data.object[0]?.param);
          this.elementParams = Object.entries(formData).map(([key, value]) => ({ key, value }));
          await this.$nextTick();
          if (this.routerParams.viewParam === "view") {
            this.fapi.coverValue(formData);
            this.fapi.disabled(true);
          } else {
            this.getFormElementPermissions(1);
          }
        } else {
          const param = res.data.object.param ? JSON.parse(res.data.object.param) : '';
          this.messageObj = param ? { ...res.data.object, ...param } : res.data.object;
          this.$refs.businessForm.setFormData(this.messageObj || {});
          // revit查看流程时，fileInfoList里吧uploadType等于0的放到表单模型里
          if (this.routerParams.clientType === 2 && this.routerParams.startFlowMode === 1) {
            if (this.routerParams.flowKey === "tz" || this.routerParams.flowKey === "check") {
              // 模型列表
              const modelList = res.data.fileInfoList.filter((ele) => ele.uploadType === 0);
              this.$refs.businessForm.setModelList(modelList);
            }
            const fileInfoList = res.data.fileInfoList.filter((ele) => ele.uploadType !== 0);
            this.floderData = fileInfoList;
          } else {
            this.floderData = res.data.fileInfoList || [];
          }
          this.$refs.businessForm.flowStatus = true;
          if (this.routerParams.viewParam === "approve") {
            this.$refs.userApprove.floderData = this.floderData;
          }
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    async getProcessDetail() {
      const res = await flowService.queryInstanceNodes(this.routerParams.flowInstanceId);
      this.$refs.applicationFlow.setNodeList(res.data);
      if (res.data[0].assigneeList[0].userId === this.routerParams.userId) {
        this.isShow = this.routerParams.status;
      } else {
        this.isShow = "";
      }
      if (this.routerParams.flowKey === "check") {
        res.data.forEach((ele, index) => {
          // 审批中
          if (ele.nodeStatus === "2" && index === res.data.length - 1) {
            this.$refs.checkFlowFileEditor.flowStageName = "绑定";
            this.$refs.businessForm.flowStageName = "绑定";
          }
        });
      }
    },
    update() {
      this.isWorkbench = true;
      this.getInit();
    },
    getFormData() {
      if (this.isCustom) {
        const json = this.fapi.form;
        this.$refs.userApprove.setFormData(json);
      }
    },
    withdraw() {
      this.$confirm(`您确定撤回当前流程吗?`, "警告", { type: "warning" })
        .then(async () => {
          const dto = { flowInstanceId: this.routerParams.flowInstanceId };
          try {
            await flowService.withdraw(dto);
            this.$success("流程撤回成功");
            this.reback();
          } catch (error) {
            console.error(error);
          }
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },
    // 流程再发起
    flowAgain() {
      const params = {
        groupId: this.routerParams.groupId || "",
        flowDefinitionId: this.routerParams.flowDefinitionId,
        flowKey: this.routerParams.flowKey,
        businessFormId: this.routerParams.businessFormId,
        flowInstanceId: this.routerParams.flowInstanceId,
        currentVersionId: this.routerParams.currentVersionId,
        flowBusinessId: this.routerParams.flowBusinessId,
        viewParam: this.routerParams.viewParam,
        status: this.routerParams.status,
        readonly: false, // 用以替换 flowStatus
        ...this.routerParams,
        flowStatus: false // 放this.routerParams下面用于判断流程再发起时flowFileEditor组件下的文件能否删除
      };
      this.$store.dispatch("setRouterParams", params);
      this.$router.push({ name: "approvalRVT", query: { isFlowRestart: "yes" }});
    },
    async reback() {
      await CefSharp.BindObjectAsync("cefSharpBrower");
      cefSharpBrower.closeWindow();
    },
    setFlowInstanceNodeId(flowInstanceNodeId) {
      this.$nextTick(() => {
        if (this.routerParams.viewParam === "approve") {
          this.$refs.userApprove.setNodeId(flowInstanceNodeId);
        }
      });
    },
    setFlowApproveUser(data) {
      this.isShowUserApprove = data;
    },
    // 审批时获取文件
    getFloderData() {
      this.$refs.userApprove.setFloderData(this.floderData);
    }
  }
};
</script>

<style lang="scss" scoped>
#detail {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #fff;

  .processHeader {
    width: 100%;
    height: 50px;
    padding: 0 20px;
    background: #fff;
    border-bottom: 1px solid #ebefff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .label {
      font-weight: 700;
      font-size: 16px;
      line-height: 22px;
    }
  }

  .content {
    width: 100%;
    margin-top: 10px;
    padding: 0 20px;
    height: calc(100% - 60px);
    overflow-x: hidden;
    overflow-y: auto;

    .name {
      font-weight: 700;
      font-size: 16px;
      line-height: 15px;
      color: var(--theme-color);
      border-left: 2px solid var(--theme-color);
      padding-left: 10px;
      margin-top: 15px
    }
  }
}</style>
<style lang="scss" scoped src="./flowDetail.scss"/>
